import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { MessageCircle, Clock, MapPin, Mail, AlertTriangle } from "lucide-react";

const Contact = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "5521998000676";
    const message = encodeURIComponent(
      "Hello! I have a question about a consultation with Rio Med Care."
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:riomedcare@gmail.com";
  };

  return (
    <section id="contact" className="py-20 bg-section-bg">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Questions? Talk to Us
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto">
             No forms, no waiting rooms. Send a message and our care team replies
            during opening hours — average reply in 30 minutes.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="shadow-lg">
            <CardContent className="p-8 md:p-10">
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <Button size="lg" className="flex-1 h-14 text-base" onClick={handleWhatsAppClick}>
                  <MessageCircle className="h-5 w-5 mr-2" />
                  Ask a Question on WhatsApp
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="flex-1 h-14 text-base"
                  onClick={handleEmailClick}
                >
                  <Mail className="h-5 w-5 mr-2" />
                  riomedcare@gmail.com
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6 border-t border-border">
                <div className="flex items-start gap-3">
                  <Clock className="h-5 w-5 text-primary mt-1 shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Opening Hours</p>
                    <p className="text-sm text-text-secondary">
                      Daily, 7:00 AM – 10:00 PM (Brazil time)
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 text-primary mt-1 shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Where We Care for You</p>
                    <p className="text-sm text-text-secondary">
                      Online video consultations throughout Brazil — from your hotel,
                      apartment or anywhere with an internet connection.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3 mt-6 p-4 rounded-lg bg-destructive/10 border border-destructive/20">
                <AlertTriangle className="h-5 w-5 text-destructive mt-0.5 shrink-0" />
                <p className="text-sm text-foreground">
                  In a medical emergency, call <strong>192 (SAMU)</strong> or go to the
                  nearest emergency department. This service is not for emergencies.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;
